// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerDetalhesMaterial {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding-left: 45px;
  width: calc(100% - 45px);
  margin-bottom: 30px;
}

.containerDetalhesMaterial .upperHome {
  padding: 10px 0;
  border-bottom: 1px solid #77797b;
}

.containerDetalhesMaterial .containerStatus .titleBlock {
  font-size: 20px;
}

.teste {
  display: flex;
  position: relative;
  z-index: 1000;
}

.containerMaterial {
  display: flex;
  padding: 0px 0px 0 82px;
  width: calc(100% - 112px);
  flex-direction: row;
  justify-content: space-between;
}

.column-1 {
  width: 52%;
}

.column-2 {
  width: 47%;
  max-height: 429px;
}

.atributtes,
.params,
.nve,
.ipi,
.destaque_imp,
.destaque_exp {
  overflow-y: auto;
  scrollbar-color: #000 transparent;
  scrollbar-width: thin;
  max-height: 250px;
  margin-bottom: 15px;
  background: #fff;
}

.nve {
  max-height: 126px;
  min-height: 126px;
}

.destaque_exp,
.ipi,
.destaque_imp {
  max-height: 83px;
  min-height: 83px;
}

.params {
  max-height: 200px;
  margin-bottom: 40px;
  border: 1px solid #e0e2e5;
}

.params ul,
.atributtes ul,
.nve ul,
.ipi ul,
.destaque_imp ul,
.destaque_exp ul {
  margin: 0;
  padding: 0;
}

.params ul li,
.atributtes ul li,
.nve ul li,
.ipi ul li,
.destaque_imp ul li,
.destaque_exp ul li {
  list-style: none;
  border-bottom: 1px solid #ccc;
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 10px 0;
  background: #fff;
}

.params ul li:first-child {
  display: none;
}

.params ul li span,
.atributtes ul li span,
.nve ul li span,
.ipi ul li span,
.destaque_exp ul li span,
.destaque_imp ul li span {
  margin-left: 20px;
  margin-right: 10px;
  font-weight: 600;
}

.params ul li p,
.atributtes ul li p,
.nve ul li p,
.ipi ul li p,
.destaque_imp ul li p,
.destaque_exp ul li p {
  margin: 0;
}

.h2-material {
  background-color: #fff;
  text-align: left;
  font-weight: 700;
  font-size: 17px;
  margin: 0;
  padding: 14px 20px;
  border-bottom: 1px solid #77797b;
}

.containerDowload {
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-bottom: 12px;
  min-height: 4 0px;
}

.titleComments {
  color: #004975;
  margin-bottom: 5px;
  font-size: 20px;
}

.bodyComments {
  border: 1px #dcdcdc solid;
  display: flex;
  min-height: 50px;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 10px;
  color: #000000;
}

.semComments {
  color: #979ea4cc;
}

.textMessage {
  display: flex;
  align-items: center;
  margin-top: 5px;
  background-color: #ececec;
  padding-left: 10px;
  padding-right: 10px;
  min-height: 25px;
}

.textData {
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
  padding-left: 10px;
  font-size: 13px;
}

.containerDownloadImages {
  margin-top: 25px;
}

.containerItensImgDownload {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
}

.detalhes-material-bg {
  background-color: #eff1f2;
}

.css-1tyt2d0-MuiPagination-root {
  margin-bottom: 30px;
}

.noResults {
  color: #979ea4;
  padding: 10px 20px;
  display: block;
}

.resetModalBody {
  margin-top: -5px;
  margin-bottom: 10px;
  
}
`, "",{"version":3,"sources":["webpack://./src/pages/DetalhesMaterial/detalhesMaterial.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;;;;;;EAME,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;;;EAGE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;;;EAME,SAAS;EACT,UAAU;AACZ;;AAEA;;;;;;EAME,gBAAgB;EAChB,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;;;EAME,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;;;EAME,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;;AAErB","sourcesContent":[".containerDetalhesMaterial {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding-left: 45px;\n  width: calc(100% - 45px);\n  margin-bottom: 30px;\n}\n\n.containerDetalhesMaterial .upperHome {\n  padding: 10px 0;\n  border-bottom: 1px solid #77797b;\n}\n\n.containerDetalhesMaterial .containerStatus .titleBlock {\n  font-size: 20px;\n}\n\n.teste {\n  display: flex;\n  position: relative;\n  z-index: 1000;\n}\n\n.containerMaterial {\n  display: flex;\n  padding: 0px 0px 0 82px;\n  width: calc(100% - 112px);\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.column-1 {\n  width: 52%;\n}\n\n.column-2 {\n  width: 47%;\n  max-height: 429px;\n}\n\n.atributtes,\n.params,\n.nve,\n.ipi,\n.destaque_imp,\n.destaque_exp {\n  overflow-y: auto;\n  scrollbar-color: #000 transparent;\n  scrollbar-width: thin;\n  max-height: 250px;\n  margin-bottom: 15px;\n  background: #fff;\n}\n\n.nve {\n  max-height: 126px;\n  min-height: 126px;\n}\n\n.destaque_exp,\n.ipi,\n.destaque_imp {\n  max-height: 83px;\n  min-height: 83px;\n}\n\n.params {\n  max-height: 200px;\n  margin-bottom: 40px;\n  border: 1px solid #e0e2e5;\n}\n\n.params ul,\n.atributtes ul,\n.nve ul,\n.ipi ul,\n.destaque_imp ul,\n.destaque_exp ul {\n  margin: 0;\n  padding: 0;\n}\n\n.params ul li,\n.atributtes ul li,\n.nve ul li,\n.ipi ul li,\n.destaque_imp ul li,\n.destaque_exp ul li {\n  list-style: none;\n  border-bottom: 1px solid #ccc;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  padding: 10px 0;\n  background: #fff;\n}\n\n.params ul li:first-child {\n  display: none;\n}\n\n.params ul li span,\n.atributtes ul li span,\n.nve ul li span,\n.ipi ul li span,\n.destaque_exp ul li span,\n.destaque_imp ul li span {\n  margin-left: 20px;\n  margin-right: 10px;\n  font-weight: 600;\n}\n\n.params ul li p,\n.atributtes ul li p,\n.nve ul li p,\n.ipi ul li p,\n.destaque_imp ul li p,\n.destaque_exp ul li p {\n  margin: 0;\n}\n\n.h2-material {\n  background-color: #fff;\n  text-align: left;\n  font-weight: 700;\n  font-size: 17px;\n  margin: 0;\n  padding: 14px 20px;\n  border-bottom: 1px solid #77797b;\n}\n\n.containerDowload {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  margin-bottom: 12px;\n  min-height: 4 0px;\n}\n\n.titleComments {\n  color: #004975;\n  margin-bottom: 5px;\n  font-size: 20px;\n}\n\n.bodyComments {\n  border: 1px #dcdcdc solid;\n  display: flex;\n  min-height: 50px;\n  border-radius: 4px;\n  padding: 15px;\n  margin-bottom: 10px;\n  color: #000000;\n}\n\n.semComments {\n  color: #979ea4cc;\n}\n\n.textMessage {\n  display: flex;\n  align-items: center;\n  margin-top: 5px;\n  background-color: #ececec;\n  padding-left: 10px;\n  padding-right: 10px;\n  min-height: 25px;\n}\n\n.textData {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 5px;\n  padding-left: 10px;\n  font-size: 13px;\n}\n\n.containerDownloadImages {\n  margin-top: 25px;\n}\n\n.containerItensImgDownload {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  align-items: center;\n}\n\n.detalhes-material-bg {\n  background-color: #eff1f2;\n}\n\n.css-1tyt2d0-MuiPagination-root {\n  margin-bottom: 30px;\n}\n\n.noResults {\n  color: #979ea4;\n  padding: 10px 20px;\n  display: block;\n}\n\n.resetModalBody {\n  margin-top: -5px;\n  margin-bottom: 10px;\n  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
